import { useSearchParams } from 'react-router-dom';
import { PageTab } from '@/components/TabbedPage';
import { TiktokShell } from '@/components/tiktok/TiktokShell';
import TiktokReporting from './TiktokReporting';
import TiktokAudiences from './TiktokAudiences';
import TiktokPixel from './TiktokPixel';
import TiktokEventRules from './TiktokEventRules';
import TiktokLeadForms from './TiktokLeadForms';
import { BarChart2, Target, Activity, Zap, ClipboardList } from 'lucide-react';

// Reporting / Audiences / Pixel / Instant Forms / Event Rules are the
// measurement-and-targeting side of the TikTok integration — one sidebar entry.
const TABS: Array<PageTab & { description: string }> = [
  {
    id: 'reporting',
    label: 'Reporting',
    icon: <BarChart2 size={14} />,
    description: 'Spend, reach and conversions per campaign, ad group or ad, with a day-by-day drill-down.',
    render: () => <TiktokReporting embedded />,
  },
  {
    id: 'audiences',
    label: 'Audiences',
    icon: <Target size={14} />,
    description: 'Custom and lookalike audiences built from CRM contact groups for ad targeting.',
    render: () => <TiktokAudiences embedded />,
  },
  {
    id: 'pixel',
    label: 'Pixel',
    icon: <Activity size={14} />,
    description: 'Pixels, their conversion events and the install snippet; send server-side test events.',
    render: () => <TiktokPixel embedded />,
  },
  {
    id: 'lead-forms',
    label: 'Instant Forms',
    icon: <ClipboardList size={14} />,
    description: 'Lead-generation forms hosted by TikTok, selectable on Leads ads.',
    render: () => <TiktokLeadForms embedded />,
  },
  {
    id: 'event-rules',
    label: 'Event Rules',
    icon: <Zap size={14} />,
    description: 'Map CRM events (deal won, lead qualified) to TikTok pixel events; sent manually for now.',
    render: () => <TiktokEventRules embedded />,
  },
];

export default function TiktokToolsManager() {
  // TabbedPage owns the ?tab= param; read it here only to vary the description.
  const [params, setParams] = useSearchParams();
  const active = TABS.find((t) => t.id === params.get('tab')) ?? TABS[0];

  return <TiktokShell section="Measurement" title="Measurement" description="Understand results, build audiences and connect your conversion tracking.">
    <div className="tt-tabs" aria-label="Measurement tools">{TABS.map((t) => <button key={t.id} aria-pressed={active.id === t.id} onClick={() => setParams({ tab: t.id })}>{t.icon}{t.label}</button>)}</div>
    <div className="tt-embedded">{active.render()}</div>
  </TiktokShell>;
}
